// extracted by mini-css-extract-plugin
export default {"title":"_00d3dfd059","bld":"e0ddf015cf"};